/**
 * Labstep
 *
 * @module components/EntityImport/Action/Menu
 * @desc Action Menu for group
 */

import { EntityImportActionDelete } from 'labstep-web/components/EntityImport/Action/Delete';
import { EntityImportActionRevert } from 'labstep-web/components/EntityImport/Action/Revert';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { EntityImportActionMenuProps } from './types';

export enum Action {
  revert = 'revert',
  delete = 'delete',
  start = 'start',
}

export const EntityImportActionMenu: React.FC<
  EntityImportActionMenuProps
> = ({ entityImport, type, actions = [] }) => {
  return (
    <ActionMenu type={type}>
      {actions.includes(Action.delete) && (
        <EntityImportActionDelete entity={entityImport} />
      )}
      {actions.includes(Action.revert) && (
        <EntityImportActionRevert entityImport={entityImport} />
      )}
    </ActionMenu>
  );
};

EntityImportActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
